import { Http } from "../utils/http.js";

export class FileService {
  download(id) {
    var url = "document/download";
    var postData = {
      miscFileParameter: {
        fileId: id,
      },
    };
    return new Http().post(url, postData);
  }

  upload(fileName, base64String, cat) {
    var url = "document/upload";
    var postData = {
      miscFileParameter: {
        fileName: fileName,
        base64FileString: base64String,
        fileCategory: cat,
      },
    };
    return new Http().post(url, postData);
  }
}
